import React from 'react';
import ReactDOM from 'react-dom';
import Neutronium from './Neutronium';

ReactDOM.render(
  <Neutronium />,
  document.querySelector('#root'),
);
